<template>
  <div class="pumpBolusDetailTable_ctn" :class="{ 'pumpBolusDetailTable_ctn--long': isLongLanguage, 'pumpBolusDetailTable_ctn--fullPage': fullPageTable }" :style="style">
    <el-table
      :data="tableData"
      border
      :show-header="false"
      :style="table1Style"
      :cell-class-name="tableCellClassName"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="c0"
        label=""
        class-name="first-column"
        :width="cellWidth0"
      >
        <template slot-scope="scope">
          <div class="cell_date">
            {{ scope.row.c0 }}
          </div>
          <!-- <div class="cell_date cell-ellipsis cell_date--tip" v-if="!scope.row.isSum"> -->
          <!--   {{ scope.row.c0 }} -->
          <!-- </div> -->
        </template>
      </el-table-column>
      <el-table-column
        v-for="v in maxColumnCountV2"
        :key="`pumpBolusDailyTable_column${v}_${id}`"
        :prop="`c${v}`"
        :class-name="v === maxColumnCountV2 ? 'last-column' : ''"
        label=""
        :width="cellWidth"
      >
        <template slot-scope="scope">
          <span v-if="scope.row['isNoRow'] && scope.row[`c${v}`]" class="isNoCell">{{ scope.row[`c${v}`] }}</span>
          <span v-if="!scope.row['isNoRow']">{{ scope.row[`c${v}`] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>  
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import { Table, TableColumn } from 'element-ui'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory } from '@u/log'
import { findObjIndexInArray } from '@u'
import { _getMergedPumpBigDosageFromRecords, _getPumpBigDosageFromRecords } from '@u/reportHelper'
import { bolusDetailNeedSplitColumnNum } from '@u/reportHelperPump'
const derror = derrorFactory('PumpBolusDetailTable.vue', true)
const error = errorFactory('PumpBolusDetailTable.vue', true)

function _emptyUseDash(str) {
  if (['', 'undefined', 'null', 'NULL', 'NaN', 'nan'].includes(`${str}`)) {
    return '--'
  } else {
    if (`${str}` === '-') {
      return ''
    }
    return `${str}`
  }
}

let _id = 1
export default {
  name: 'CPumpBolusDetailTableRu',
  components: {
    elTable: Table,
    elTableColumn: TableColumn
  },
  mixins: [reDrawTrigger],
  props: {
    quickPumpTagList: { // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      type: [Array],
      default: () => []
    },
    showMarginRight: {
      type: [Number, Boolean, String],
      default: true
    },
    isLongLang: {
      type: [Number, Boolean, String],
      default: false
    },
    fullPageTable: {
      type: [Boolean],
      default: false
    },
    value: {
      type: [Object],
      default: () => {}
    },
    calculators: {
      type: [Array],
      default: () => []
    },
    otherData: {
      type: [Array],
      default: () => []
    }
  },
  data() {
    _id++
    const id = `bolusdailyt_${+new Date()}_${_id}`
    const { fullPageTable, isLongLang } = this
    let maxColumnCount = bolusDetailNeedSplitColumnNum(this.lang) // 最多多少列
    derror(`fullPageTable: ${fullPageTable}, isLongLang: ${isLongLang}`)
    if (fullPageTable) {
      maxColumnCount = 18
    } else {
      if (isLongLang) {
        // maxColumnCount -= 1
        maxColumnCount -= 0
      }
    }
    return {
      id,
      maxColumnCount
    }
  },
  computed: {
    maxColumnCountV2() {
      const { mergedBigDosage = [] } = this
      const d = 4
      return mergedBigDosage.length === 0 ? d : (Math.max(d, mergedBigDosage.length))
    },
    mergedBigDosage() {
      const { value, secondPart, maxColumnCount, fullPageTable } = this
      const { threeChartData = {}} = value
      const { insulinChart = {}} = threeChartData
      const { list2: pumpRecord } = insulinChart
      const bigDosageMinWidthMinutes = 15 // 这个值变了，也要修改ChartDailyPump里头写死的值      
      
      if (!fullPageTable) {
        // 非一整页渲染
        const bigDosage = _getPumpBigDosageFromRecords(pumpRecord, bigDosageMinWidthMinutes)
        const _rst = _getMergedPumpBigDosageFromRecords(bigDosage, bigDosageMinWidthMinutes)
        const rl = _rst.length
        // const rst = secondPart ? _rst.splice(9) : _rst // 其实如果不是secondPart的话，应该取_rst.splice(9)之后的_rst，但这里就懒得处理了
        const rst = rl > maxColumnCount ? _rst.splice(0, maxColumnCount) : _rst // 取前maxColumnCount
        // const rst = Array.from({ length: 22 }).map(v => {
        //   // eslint-disable-next-line
        //   return {}
        // })
        return rst
      } else {
        // 一整页渲染Pump Bolus Detail Table
        // 此时insulinChart.list2为已经处理好的merged big dosage records
        const _rst = pumpRecord
        const rl = _rst.length
        // const rst = rl > maxColumnCount ? _rst.splice(maxColumnCount) : [] // 取偏移maxColumnCount后的数组
        const rst = rl > maxColumnCount ? _rst.splice(0, maxColumnCount) : _rst // 取前maxColumnCount
        // const rst = Array.from({ length: 22 }).map(v => {
        //   // eslint-disable-next-line
        //   return {}
        // })
        return rst        
      }
    },
    cellWidth0() {
      const { lang = 'en', isLongLanguage } = this
      
      // 多语言      
      let rst = 240 // english
      
      // 捷克语再宽一点
      if (isLongLanguage) { // 改成和捷克语一样
        rst = 389
        /* eslint-disable */
        switch(`${lang}`) {
        case 'pl':
          rst = 389
          break
        case 'es': // 西班牙语Carbs Ratio Setting会显示成3行，所以再宽一点
          rst = 380
          break
        case 'cs': // 捷克语再宽一点
        default:
          rst = 389
          break
        }
      }
      /* eslint-enable */
      
      derror(`cellWidth0: ${rst}, lang: ${lang}, isLonglanguage: ${isLongLanguage}`)
      return rst
    },
    cellWidth() {
      const { lang = 'en', isLongLanguage } = this
      
      // 强制都改成90，因为'Bolus Type'已经改成用简称了
      let rst = 96 // english
      if (isLongLanguage) {
        rst = 90
      }
      
      /* eslint-disable */
      switch(`${lang}`) {
      case 'es': // 西班牙语Carbs Ratio Setting会显示成3行，所以这里窄一点
      case 'pl': // 波兰语Carbs Ratio Setting会显示成3行，所以这里窄一点
        rst = 82
        break
      }
      /* eslint-enable */
      
      derror(`cellWidth: ${rst}`)
      return rst
    },
    table1Style() {
      const { cellWidth, cellWidth0, maxColumnCountV2 } = this
      const rst = {
        width: `${cellWidth * maxColumnCountV2 + 2 + cellWidth0}px`,
        marginRight: `2px`,
        'overflow-x': 'hidden'
      }
      return rst
    },
    quickBolusRespectDosageIndexList() { // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      const { value, quickPumpTagList = [], mergedBigDosage = [] } = this
      const { date } = value
      
      if (!quickPumpTagList.length || !mergedBigDosage.length) {
        return []
      }
      
      const dfmt = 'YYYY-MM-DD'
      const currentDateQuickPumps = quickPumpTagList.filter(obj => {
        return dayjs(date).format(dfmt) === dayjs(obj.dateTimeStr).format(dfmt)
      })
      
      const buffer = 60 // 秒为单位;这个buffer用来寻找根据 quickPumpTagList的时间戳，找到到对应的大剂量记录(前后浮动{buffer}时长)
      
      const list = (currentDateQuickPumps.map((obj, i) => {
        const time = obj.dateTimeStr
        
        const respectBigDosageIndex = findObjIndexInArray(mergedBigDosage, { check_time: time }, function _sameTime(v, compareToMeObj) {
          let same = false
          
          const t1 = dayjs(v['check_time'])
          const t2 = dayjs(compareToMeObj['check_time'])
          
          if (Math.abs(t1 - t2) - buffer * 1000 <= 0) {
            same = true
          }
          
          return same
        })
        
        if (respectBigDosageIndex < 0) {
          error(`[接口数据返回有问题但逻辑不会崩]，字段quickPumpTagList的${i}下标的值，其dateTimeStr: ${time}。理论上应该在mergedBigDosage里头应该能找到一条记录记录，其check_time在${time}的前后1分钟. mergedBigDosage: `, mergedBigDosage)
          return undefined
        }
        
        return +respectBigDosageIndex
      })).filter(v => v >= 0)
      
      return list
    },
    tableData() {
      const { maxColumnCount, fullPageTable, value } = this
      const { date, calculatorList = [] } = value
      
      const _isMgUnit = this.unit && /mg/i.test(this.unit)
      // const _unitRatio = _isMgUnit ? 1 : (1 / 18)
      const _unitRatio = 1 // 服务端说他处理了
      
      // const _rows = [`Bolus No.`, `Time`, `Bolus Type`, `Recommended Bolus`, `Correction Bolus`, `Difference`, `Carbs`, `Carbs Ratio Setting`, `BG`, `BG Target Setting`, `Insulin Sensitivity`, `Active Insulin`]
      const _rows = [`Bolus No.`, `Time`, `BG`, `BG Target Setting`, `Bolus Type`, `Carbs`, `Carbs Ratio Setting`, `Meal Bolus`, `Correction Bolus`, `Insulin Sensitivity`, `Active Insulin`, `Recommended Bolus`, `Difference`, `Bolus Delivery`]
      
      const rst = _rows.map((k, i) => {
        const rst = { c0: this.$t(k) }
        if (k === `Bolus No.`) {
          rst.isNoRow = true
        }
        if (i + 1 === _rows.length) {
          // 最后一行
          rst.isLastRow = true
        }
        return rst
      })
      
      const buffer4CarbsAndGlu = 1000 * 60 // 1分钟;获取Carbs和BG的记录的偏移量，最多1分钟
      
      const l = calculatorList.length
      for (let i = 0; i < l; i++) {
        const $cal = calculatorList[i] || {}
        
        const columnK = `c${i + 1}`
        // Bolus No.
        const bIndex = _rows.indexOf(`Bolus No.`)
        rst[bIndex][columnK] = (i + 1 + (fullPageTable ? bolusDetailNeedSplitColumnNum(this.lang) : 0))
        
        // Time
        const bIndex1 = _rows.indexOf(`Time`)
        rst[bIndex1][columnK] = dayjs($cal.appTime).format('HH:mm')
        
        // Bolus Type
        const bIndex2 = _rows.indexOf(`Bolus Type`)
        rst[bIndex2][columnK] = '--'
        
        // 画Recommended到表格
        const bIndex3 = _rows.indexOf(`Recommended Bolus`)
        let trueBolusV = $cal.bolusConfirmValue
        let recommandBolusV = $cal.bolusValue
        if (+$cal?.event === 513) {
          trueBolusV = $cal.totalBolusOrBasalId
          recommandBolusV = _noData(recommandBolusV) ? '--' : recommandBolusV
        }

        rst[bIndex3][columnK] = _emptyUseDash(recommandBolusV)
        
        // 画difference到表格
        const bIndex5 = _rows.indexOf(`Difference`)
        
        rst[bIndex5][columnK] = _emptyUseDash(trueBolusV - recommandBolusV)
        
        // 画Carbs到表格
        const bIndex6 = _rows.indexOf(`Carbs`)
        rst[bIndex6][columnK] = $cal.carbohydrate
        if (rst[bIndex6][columnK]) {
          rst[bIndex6][columnK] += 'g'
        }
        rst[bIndex6][columnK] = _emptyUseDash(rst[bIndex6][columnK])
        
        // 画CarbRatio到表格
        const bIndex7 = _rows.indexOf(`Carbs Ratio Setting`)
        rst[bIndex7][columnK] = _emptyUseDash($cal.defaultCho)
        
        // 画BG到表格
        const bIndex8 = _rows.indexOf(`BG`)
        const bIndex8DigitNum = _isMgUnit ? 0 : 1
        rst[bIndex8][columnK] = _emptyUseDash(+$cal.bloodGlucose?.toFixed(bIndex8DigitNum))
        
        // 画BGSETTING到表格
        const bIndex9 = _rows.indexOf(`BG Target Setting`)
        rst[bIndex9][columnK] = ''
        const bIndex9DigitNum = _isMgUnit ? 0 : 1
        const bIndex9Middle = (+$cal.bgHighLimit + +$cal.bgLowLimit) / 2 * _unitRatio
        const bIndex9NoData = _noData($cal.bgHighLimit) || _noData($cal.bgLowLimit)
        rst[bIndex9][columnK] = _emptyUseDash(bIndex9NoData ? '' : bIndex9Middle.toFixed(bIndex9DigitNum))
        
        const bIndex12 = _rows.indexOf(`Meal Bolus`)
        let mealBolus
        do {
          const carbs = $cal.carbohydrate
          const ratio = $cal.defaultCho
          
          if (+ratio !== 0) {
            mealBolus = (carbs / ratio).toFixed(1)
          }
          // eslint-disable-next-line
        } while (false)
        // 画meal bolus到表格
        rst[bIndex12][columnK] = _emptyUseDash(mealBolus)

        const bIndex4 = _rows.indexOf(`Correction Bolus`)        
        let cBolus
        let correctionBg = 0
        do {
          const bg = +$cal['bloodGlucose']
          const min = Math.min(+$cal.bgHighLimit, +$cal.bgLowLimit)
          const max = Math.max(+$cal.bgHighLimit, +$cal.bgLowLimit)
          
          if (bg - min >= 0 && bg - max <= 0) {
            // 不矫正
            correctionBg = 0
          } else {
            correctionBg = bg - (min + max) / 2
          }
          // eslint-disable-next-line
        } while (false)
        // 画Correction Bolus到表格
        rst[bIndex4][columnK] = _emptyUseDash((Math.abs(correctionBg * _unitRatio) / $cal.sensitiveSilver).toFixed(1))
        
        // insulin sensitivity画到表格
        const bIndex10 = _rows.indexOf(`Insulin Sensitivity`)
        rst[bIndex10][columnK] = _emptyUseDash($cal.sensitiveSilver)
        
        // 画active insulin到表格:活性胰岛素
        const bIndex11 = _rows.indexOf(`Active Insulin`)
        rst[bIndex11][columnK] = _emptyUseDash($cal.effectiveInsulin)
        
        // 计算Bolus Delivery
        // 画active insulin到表格
        const bIndex13 = _rows.indexOf(`Bolus Delivery`)
        rst[bIndex13][columnK] = _emptyUseDash(_noData(trueBolusV) ? '' : trueBolusV)
      }
      
      console.error(`大剂量计算器rst`, rst)
      return rst

      function _noData(v) {
        return ['', 'undefined', 'null'].includes(`${v}`)
      }
    },
    h() {
      const dh = this.dh
      
      const r = 221 / 1240
      // derror(`[bar]computed h: ${dh}, rst: ${r * dh}`)
      return r * dh
    },
    w() {
      const ds = this.ds
      
      const r = 455 / 1754
      // error(`[bar]computed w: ${ds}, rst: ${r * ds}`)
      return r * ds
    },
    style() {
      const { showMarginRight, zoomRatio, isLongLanguage } = this
      const rst = { zoom: zoomRatio * 0.836 } // 测试反馈，页面能渲染，但是当他点击打印，然后打印预览的时候，发现这个表格消失了，应该是太大导致溢出了

      if (isLongLanguage) {
        // rst.zoom = rst.zoom * 0.9
        // rst.zoom = rst.zoom * 0.8999
        rst.zoom = rst.zoom * 1
      } else {
        rst.zoom = rst.zoom * 0.9
        // rst.zoom = rst.zoom * 1
      }
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    }
  },
  mounted() {
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      const i = `${rowIndex}`
      if (i === '0') {
        return 'first-row'
      } else if (row && row.isLastRow) {
        return 'last-row'
      }
      return ''
    },
    tableCellClassName({ row = {}, column = {}}) {
      const { property = '' } = column
      const ps = `${property}`
      if (ps === 'cell11') {
        return 'corner_cell--bright'
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
$br: 0.8em;  
$br--px: 8px;
$fs--px: 14px;
$fs-small--px: 12px;
$fs-large--px: 16px;
$fs-biggest--px: 20px;
$c: #454545;
$c-tableStripped: #E7F1EC;

@import '@/styles/mixin';
@import '@/styles/variables';
::v-deep .el-table {    
    color: $c;
    .cell-ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    &.el-table--border {
        border-radius: $br--px;
        border-radius: $br;
    }
    .cell {
        padding: 0 0;
        padding-left: 0;
        line-height: 18px;
        font-size: 16px;
        font-size: $fs-biggest--px;
        > span {
            display: inline-block;
            &.isNoCell {
                background-color: #0f7a44;
                color: white;
                padding: 2px 4px;
                display: inline-block;
                $h: 1.2em;
                width: 1.3em;
                height: $h;
                line-height: $h;
                text-align: center;
            }
        }
    }
    .el-table__cell {
        padding: 0 0;
    }
    tr.el-table__row > .el-table__cell {
        position: relative;
        > .cell {
            height: 100%;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            > div {
                flex-grow: 1;
                word-break: break-word;
                /* word-break: break-all; */
                width: 100%;
                /* overflow: hidden; */
                /* white-space: nowrap; */
                /* text-overflow: ellipsis; */
                /* @include heightMiddle($rowH); */
                height: $rowH;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                text-align: center;
            }
        }
    }
}
::v-deep .el-table--border .el-table__cell:first-child .cell {
    padding-left: 0;
}
::v-deep .withSplitter {
    > td {
        border-bottom: 2px solid black;
    }
}
.cell_date {
    text-align: right;
    font-size: $fs-small--px;
    &.cell_date--tip {
        font-size: $fs-small--px;
        opacity: 0.6;
    }
    &.cell_date--isSum {
        @include flexColumn(space-around, flex-end);
    }
}
.first-column .cell_date {
    font-size: $fs-biggest--px;
}
.pumpBolusDetailTable_ctn--long .cell_date {
    font-size: $fs-large--px;
    font-size: 20px;
}

::v-deep .el-table__header-wrapper {
    > table {
        height: 40px;
        background-color: #FAFAFA;
    }
    thead > tr > th {
        overflow: visible;
        border-right: 0;
        background-color: #D8D8D8;
        height: 48px;
        > .cell {
            left: -1.4em;
            padding-left: 0;
            padding-right: 0;
            font-size: $fs--px;
        }
        &:nth-last-child(2) {
            > .cell {
                left: 0;
                overflow: visible;
                white-space: nowrap;
                direction: rtl;
                text-indent: 2px;
            }
        }
    }
}
::v-deep .el-table__footer-wrapper {
    .el-table__footer {
        height: 36px;
        tbody > tr > td.el-table__cell {
            text-align: center;
        }
    }    
}
::v-deep .el-table--striped .el-table__body {
    tr.el-table__row td.el-table__cell {
        background: #FAFAFA;
        background: aliceblue;
        background: $colorGluMesurementLabelBg;
        /* background-color: rgba(15, 122, 68, 0.10); */
    }
    
    tr.el-table__row--striped td.el-table__cell {
        background: white;
    }    
}
.pumpBolusDetailTable_ctn {
    &.pumpBolusDetailTable_ctn--fullPage {
        margin-top: 2rem;
    }
    ::v-deep {
        box-sizing: border-box;
        overflow: hidden;
        .corner_cell--bright {
            border-bottom-right-radius: $br--px;
            border-bottom-right-radius: $br;
        }
        .corner_cell--bottom {
            border-bottom-left-radius: $br--px;
            border-bottom-left-radius: $br;
            border-bottom-right-radius: $br--px;
            border-bottom-right-radius: $br;
        }
        .cell_padRight {
            border-right: 10px solid #d8d8d8;
        }

        > div.el-table {
            display: inline-block;
            border: 1px solid $colorGluMesurementInnerBorder;
            tr.el-table__row {
                height: $rowH;
                @include bBox;
                &.last-row {
                    height: $rowH + 1px;
                }
            }
        }
    }

    ::v-deep .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px solid $colorGluMesurementInnerBorder;
    }
    ::v-deep .el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid $colorGluMesurementInnerBorder;
        /* border-right-width: 0; */
    }
    ::v-deep .el-table .first-row, ::v-deep .el-table .first-column {
        background-color: $c-tableStripped;
    }
    ::v-deep .el-table .first-row td.el-table__cell {
        border-top: 1px solid $colorGluMesurementInnerBorder;
        border-top-width: 0;
        &:first-child {
            border-top-left-radius: 1em;
        }
        &:last-child {
            border-top-right-radius: 1em;
        }
    }
    ::v-deep .el-table .last-row td.el-table__cell {
        border-bottom: 2px solid $colorGluMesurementInnerBorder;
        border-bottom-width: 0;
        &:first-child {
            border-bottom-left-radius: 1em;
        }
        &:last-child {
            border-bottom-right-radius: 1em;
        }        
    }
    ::v-deep .el-table td.el-table__cell.first-column {
        border-left: 1px solid $colorGluMesurementInnerBorder;
        border-left-width: 0;
        > .cell {
            > .cell_date {
                align-items: flex-start;
                text-align: left;
                /* text-indent: 0.2em; */
                padding: 0 0.2em;
                box-sizing: border-box;
            }
        }
    }
    ::v-deep .el-table td.el-table__cell.last-column {
        border-right-width: 0;
    }
}
</style>
